import React, { useState } from 'react';

import './Survey.scss';

export default function Survey(props) {
  const { item, username, addSurveyAnswer } = props;

  const [selectedOption, setOption] = useState({});

  if (!item || !item.question) return null;

  return (
    <section id="survey">
      <p>{item.question}</p>

      <ul id="survey_options">
        {item.options.map((option, idx) => (
          <li key={idx}>
            <input
              name="option"
              type="checkbox"
              checked={selectedOption.label === option.label}
              onChange={() => setOption(option)}
              id={`survey_checkbox_${idx + 1}`}
            />

            <label htmlFor={`survey_checkbox_${idx + 1}`}>{option.label}</label>
          </li>
        ))}
      </ul>

      <button onClick={() => sendAnswer()} id="survey_button">
        Verzenden
      </button>

      <p id="survey_bottom_text">
        Dit onderzoek is opgezet door <span>Joolz</span>
      </p>
    </section>
  );

  function sendAnswer() {
    if (!selectedOption.value) return;

    addSurveyAnswer({
      variables: {
        username,
        surveyId: +item.id,
        answer: selectedOption.value
      }
    });
  }
}
